export default {
  loginTitle: 'GEAR 登录',
  login: '立即登录',
  placehdUsern: '请输入账号',
  placehdPwd: '请输入密码',
  rememberPwd: '记住密码',
  forgetLoginInfo: '忘记密码',
  noAccountMsg: '还没有账号?',
  noAccountMsg2: '', // 占位占位占位占位占位占位占位占位占位占位占位占位占位占位占位占位占位我占占占

  registerTitle: 'GEAR 注册',
  registerSuccess: '注册成功',
  register: '立即注册',
  invitationCode: '邀请码',
  invitationCodeMsg: '请输入邀请码',
  mobile: '电话号码',
  useEmailLogin: '使用邮箱登录',
  useMobileLogin: '使用手机登录',

  mobileAreaCode: '区号',
  verification: '验证码',
  getVerification: '获取验证码',
  confirmPassword: '确认密码',
  mobileAreaCodeMsg: '请选择区号',
  emailMsg: '请输入邮箱',
  mobileMsg: '请输入手机号',
  email: '邮箱',
  verificationMsg: '请输入验证码',
  nextStep: '下一步',
  lastStep: '上一步',
  applyPeopleName: '顾问姓名',
  applyPeopleNameMsg: '请输入顾问姓名',
  company: '院校/机构名',
  companyMsg: '请输入院校/机构名',
  genderMsg: '请选择性别',
  departmentMsg: '请选择部门',
  positionMsg: '请选择职位',
  country: '当前居住国家/地区',
  state: '现居省份',
  city: '现居城市',
  address: '联系地址',
  addressMsg: '请输入联系地址',
  zipCode: '邮政编码',
  hasAccountMsg: '已经拥有账户?',
  hasAccountMsg2: '', // 占位占位占位占位占位占位占位占位占位占位占位占位占位占位占位占位占位我占占占

  password: '密码',
  validPwdNum: '包含字母、数字和特殊字符，8-12位',
  validPwdMsg: '两次输入密码不一致',
  validUser: '请输入正确的账号',
  loginVerification: '验证失败，请重新登录',
  noInvitationCode: '用户未填写邀请码',
  invalidInvitationCode: '邀请码无效',
  accountExpired: '该账户已经失效',
  userPawdError: '用户或密码错误！',
  resetPassword:'重置密码',
  oldpassword: '请输入旧密码',
  newpassword: '请输入新密码',
  confirmpassword: '确认密码',
  confirmreset: '确认重置',
  outReset: '退出重置',
  isOut: '是否退出重置密码',
  operaConfirmTips: '操作确认',
  confirm: '确定',
  cancel: '取消',
  cancelOut: '取消退出',
  twopsdNotConsistent: '两次输入密码不一致!',
  passwordResetFailed:'重置密码失败',
  passwordResetSuccessful:'重置密码成功，请重新登录',
  returnLogin: '返回登录',
  verifyEmail: '邮箱验证',
  ModifyPWD: '密码更改',
  verifyEmailSuccess: '验证成功',
  verifyInitEmailSuccess: '用户初始化验证完成！',
  passwordReset: '密码重置',
  platformLoginNotice: '请你使用该平台登录',
  upgradeNoticeTitleEn: 'Platform upgrade notice',
  upgradeNoticeTitleZh: '平台升级提示',
  upgradeNoticeLine2En: 'ISSUE platform has been migrated to GEAR 3.0 AI driven platform. You will be redirect to GEAR 3.0 automatically after 10 seconds, or please click "Access GEAR 3.0" to access immediately. ',
  upgradeNoticeLine2Zh: 'SSUE平台已迁移至GEAR 3.0人工智能平台。10秒后您将自动跳转至GEAR 3.0，或点击“访问GEAR 3.0”立即访问。',
  upgradeNoticeLine3En: 'Should you have any techncial query, please contact itsupport.global@geaworld.org',
  upgradeNoticeLine3Zh: '如有任何技术问题，请联系 itsupport.global@geaworld.org',
  continueLoginZh: '继续登录',
  continueLogin: 'Continue',
  transferToNewPlatform: 'Access GEAR 3.0 ({seconds}s)',
  transferToNewPlatformZh: '访问GEAR3.0',
  roleTips: '当前角色：顾问 （如需更改角色请联系BD）',
};
